import React, { useState, createContext } from "react";
import { IAssetInfo, IViewEditForm, IViewEditSelectValue } from "../../interfaces/interface";

export const ViewEditAssetContext = createContext<any>({});

export const ViewEditAssetProvider: React.FC = (props) => {
    const [formInput, setFormInput] = useState<IViewEditForm>({
        assetName: "",
        deviceId: "",
        loadSensorId: "",
        assetType: "",
        assetDescription: "",
        profile: "",
        state: "",
    });
    const [formInputEdit, setFormInputEdit] = useState<IViewEditForm>({
        assetName: "",
        deviceId: "",
        loadSensorId: "",
        assetType: "",
        assetDescription: "",
        profile: "",
        state: "",
    });
    const [formFieldsValid, setFormFieldsValid] = useState({
        assetName: {
          displayMessage: false,
          message: ""
        },
        deviceId: {
          displayMessage: false,
          message: ""
        },
        assetType: {
          displayMessage: false,
          message: ""
        },
 
    });
    const [defaultSelectValue, setDefaultSelectValue] = useState<string>("");
    const [selectValueObj, setSelectValueObj] = useState<IViewEditSelectValue>({
      type: "",
      newType: "",
      profile: "",
      state: "",

    });
    const [profileSelectValue, setProfileSelectValue] = useState<string>("");
    const [selectValue, setSelectValue] = useState<string>("");
    const [errorMessage, setErrorMessage] =useState<string>("")
    const [assetInfoOfNewId, setAssetInfoOfNewId] = useState<IAssetInfo>({
      assetName: "",
      deviceId: "",
    })
    const [isFieldEnable,setIsFieldEnable] = useState({
      assetName: {field :true, edit: false},
      deviceId: {field :true, edit: false},
      assetType: {field :false, edit: false},
      assetDescription:{field :false, edit: false},
      profile:{field :false, edit: false},
      state:{field :false, edit: false},
  });
  return (
    <ViewEditAssetContext.Provider
      value={{
        form: [formInput, setFormInput],
        formEdit: [formInputEdit, setFormInputEdit],
        formVal: [formFieldsValid, setFormFieldsValid],
        defaultValueSelect: [defaultSelectValue, setDefaultSelectValue],
        valueSelect: [selectValue, setSelectValue],
        errMessage: [errorMessage, setErrorMessage],
        newIdAssetInfo: [assetInfoOfNewId, setAssetInfoOfNewId],
        fieldEnable: [isFieldEnable,setIsFieldEnable],
        profileValueSelect: [profileSelectValue, setProfileSelectValue],
        valueSelectObj: [selectValueObj, setSelectValueObj],
      }}
    >
      {props.children}
    </ViewEditAssetContext.Provider>
  );
};
